import {select, put} from 'redux-saga/effects';
import { pipelineOpen } from 'src/services/ui/actions';
import { addField, addPipe, deletePipe, setPipeType } from 'src/services/pipelines/actions';
import { fieldCodes } from 'src/types';
import { TYPE } from 'src/types/pipeline';
import { RESULT_SET_GROUP } from './types';

export default (flows) => {
  function* resultSetGroup({ payload }) {
    yield put(pipelineOpen());

    const pipes = yield select(state => state.pipelines.current.pipes.toJS());

    if (pipes[pipes.length - 1].type === TYPE.GROUP) {
      yield put(deletePipe(pipes.length - 1));
    }

    if (payload.length < 1) {
      return;
    }

    yield put(addPipe());

    const pipeId = yield select(state => state.pipelines.current.pipes.toJS().length - 1);

    yield put(setPipeType(pipeId, TYPE.GROUP));

    for (const field of payload) {
      yield put(addField(fieldCodes[field.name], pipeId));
    }
  }

  flows.watch(RESULT_SET_GROUP, resultSetGroup);

  return flows.getSagas();
};
